import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { DialogComponent } from './dialog.component';
import { DialogData } from '../../../store/models/dialog.model';

@Injectable()
export class DialogService {
  public isDialogOpen = false;
  private dialogRef: MatDialogRef<any>;

  constructor(public dialog: MatDialog) {
  }

  openDialog(data: DialogData): MatDialogRef<DialogComponent> {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    if (data.dialogMaxWidth) {
      dialogConfig.maxWidth = data.dialogMaxWidth;
    }

    if (data.dialogMaxHeight) {
      dialogConfig.maxHeight = data.dialogMaxHeight;
    }

    if (typeof data.canClose !== undefined) {
      dialogConfig.disableClose = !data.canClose;
    }

    if (data.onClose) {
      dialogConfig.disableClose = false;
    }

    if (data.dialogMinWidth) {
      dialogConfig.minWidth = data.dialogMinWidth;
    }

    if (data.dialogWidth) {
      dialogConfig.width = data.dialogWidth;
    }

    if (data.dialogMinHeight) {
      dialogConfig.minHeight = data.dialogMinHeight;
    }

    dialogConfig.data = data;

    this.isDialogOpen = true;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
      if (this.dialogRef && this.dialogRef.componentInstance) {
        this.dialogRef.componentInstance.onCloseEvent.next();
      }
    });

    this.dialogRef = dialogRef;

    return dialogRef;
  }

  close(result?: any) {
    if (result) {
      this.setResult(result);
    }
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  setResult(result: any): void {
    if (this.dialogRef && this.dialogRef.componentInstance) {
      this.dialogRef.componentInstance.setResult(result);
    }
  }
}
